/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import GameCard from '../../partials/GameCard';

import styles from '../../../../styles/displays/banners/games.module.scss';

const propTypes = {
    game: PropTypes.shape({}),
    games: AppPropTypes.games,
    onClickGame: PropTypes.func,
};

const defaultProps = {
    game: null,
    games: null,
    onClickGame: null,
};

function Games({ game, games, onClickGame }) {
    const themeClassName = useThemeClassName(styles);
    const { id = null } = game || {};

    // Filtered games excluding the selected game
    const otherGames = useMemo(
        () => (games || []).filter((g) => g !== null && g.id !== id),
        [games, id],
    );
    const isGrid = useMemo(() => (games || []).length > 7, [games]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.grid]: isGrid,
                },
                themeClassName,
            ])}
        >
            <div className={styles.games}>
                {game !== null ? (
                    <GameCard
                        className={classNames([styles.game, styles.selected])}
                        game={game}
                        selected
                        onClickGame={onClickGame}
                        withoutLogo
                    />
                ) : null}
                <div className={styles.otherGames}>
                    {(otherGames || []).map((g) => (
                        <GameCard
                            key={g.id}
                            className={styles.game}
                            game={g}
                            selected={g.id === id}
                            small={isGrid}
                            onClickGame={onClickGame}
                            withoutLogo
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

Games.propTypes = propTypes;
Games.defaultProps = defaultProps;

export default Games;
